import { IconButton, Tooltip } from '@mui/material';
import { CloudArrowUp, CloudCheck, CloudSlash } from '@phosphor-icons/react';
import moment from 'moment';
import React from 'react';
import { CustomColorPalette } from '../types';

interface SaveStatusButtonProps {
  saving: {
    finished: boolean;
    status: string;
    lastSaved?: string;
  };
  isOnline: boolean;
  isDarkMode: boolean;
  palette: CustomColorPalette;
}

export const SaveStatusButton: React.FC<SaveStatusButtonProps> = ({
  saving,
  isOnline,
  isDarkMode,
  palette,
}) => {
  const getTooltipText = () => {
    if (saving.lastSaved && saving.status === 'saved') {
      return `Last saved on: ${moment(saving.lastSaved).format('LT')} ${moment(
        saving.lastSaved,
      ).format('L')}`;
    }
    return '';
  };

  const getIcon = () => {
    if (!saving.finished && saving.status === 'loading') {
      return (
        <CloudArrowUp
          size={16}
          color={isDarkMode ? palette.gray.A100 : palette.neutral[700]}
        />
      );
    }
    if (isOnline && saving.status === 'saved') {
      return (
        <CloudCheck
          size={16}
          color={isDarkMode ? palette.gray.A100 : palette.neutral[700]}
        />
      );
    }
    return (
      <CloudSlash
        size={16}
        color={isDarkMode ? palette.gray.A100 : palette.neutral[700]}
      />
    );
  };

  return (
    <Tooltip title={getTooltipText()} arrow placement='bottom'>
      <IconButton
        sx={{
          width: '24px',
          height: '24px',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          borderRadius: '4px',
          border: 'none',
          backgroundColor: 'transparent',
          color: isDarkMode ? palette.gray.A100 : palette.neutral[700],
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: isDarkMode
              ? palette.gray[800]
              : palette.neutral[100],
            color: isDarkMode ? palette.gray.A100 : palette.neutral[900],
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};
